import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';

// Indique si l'utilisateur connecté est administrateur (fonction SQL is_admin()).
// Simple confort d'interface : la protection réelle des données est assurée par la RLS.
export function useIsAdmin(userId: string | undefined) {
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(Boolean(userId));

  useEffect(() => {
    if (!userId) {
      setIsAdmin(false);
      setLoading(false);
      return;
    }

    let cancelled = false;
    setLoading(true);
    supabase.rpc('is_admin').then(({ data, error }) => {
      if (cancelled) return;
      setIsAdmin(!error && data === true);
      setLoading(false);
    });

    return () => {
      cancelled = true;
    };
  }, [userId]);

  return { isAdmin, loading };
}
